module.exports = __webpack_public_path__ + "static/media/support-icon.bebdc4e4.svg";